export default class {
    constructor(params){
        this.settings = Object.assign({}, this.defaults(), params)
        this.settings.addObj = $(this.settings.baseObj).next(`.${this.settings.addBtnClass}`)
        this.setColumnObj()
        this.setAddAction()
        this.addLimitChkAction()
    }
    defaults(){
        return {
            baseObj: null,
            columnsSelector: '.columns',
            addBtnClass: 'addColumn',
            delBtnClass: 'del',
            columnClass: 'column',
            delConfirm: true,
            delConfirmMessage: 'このアイテムを削除します。よろしいですか？',
            maxSize: -1,
        }
    }
    setColumnObj(){
        this.settings.baseObj.children().each((idx, element) => {
            this.setDelAction($(element))
        })        
        let columnObj = this.settings.baseObj.children().first().clone()
        columnObj = this.editTmplObj(columnObj)
        this.clearForm(columnObj)
        columnObj.find('input,textarea').val('')
        this.setCloneObj(columnObj)
        this.settings.baseObj.data('column', columnObj)
    }
    setAddAction(){
        this.settings.addObj.on('click', event => {
            const tmpColumn = this.settings.baseObj.data('column').clone().addClass(this.settings.columnClass)
            this.setDelAction(tmpColumn)
            this.settings.baseObj.append(tmpColumn)
            this.addActionAfter(tmpColumn)
            this.addLimitChkAction()
        })
    }
    setDelAction(obj){
        obj.find(`.${this.settings.delBtnClass}`).on('click', event => {
            if (this.settings.delConfirm && !window.confirm(this.settings.delConfirmMessage)) return false
            this.settings.addObj.removeClass('hide')
            $(event.currentTarget).closest(`.${this.settings.columnClass}`).remove()
            this.delActionAfter(obj)
            this.addLimitChkAction()
        })
    }
    clearForm (obj) {
        obj
            .find("input, select, textarea")
            .not(":button, :submit, :reset, :hidden")
            .val("")
            .prop("checked", false)
            .prop("selected", false)
    }
    addLimitChkAction() {
        let cnt = this.settings.baseObj.children().length
        if (this.settings.maxSize > 0 && this.settings.maxSize <= cnt) {
            this.settings.addObj.addClass('disabled')
        } else {
            this.settings.addObj.removeClass('disabled')
        }
    }

    addActionAfter(){
        return false
    }
    delActionAfter(){
        return false
    }
    setCloneObj(){
        return false
    }
    editTmplObj(tmplObj){
        return tmplObj
    }
}